<nav class="core-nav-container">
  <ng-container *ngFor="let navItem of navBloc.coreNavSubject$ | async">
    <div class="nav-item">
      <kp-core-nav-image
        [navItem]="navItem"
        [quickActionsOpen]="quickActionsOpen"
        (navItemClicked)="quickActionsToggled.emit(false)"
        (quickActionsToggled)="quickActionsToggled.emit($event)"></kp-core-nav-image>
    </div>
  </ng-container>
</nav>
